// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2DiPf","input":"Checkbox_input__3UVZJ","control":"Checkbox_control__-RjMF","label":"Checkbox_label__2R9H7"};